import React from 'react'
import {useHistory} from 'react-router-dom'

const EvaluationPage = () => {
  const history = useHistory()
  const toEvaluation = ev => {
    history.push('/evaluation/paper/' + ev.id)
  }

  return (
    <>
      <div
        style={{
          margin: '0 auto',
          width: 1200,
          height: '100%',
          paddingTop: 40,
          backgroundColor: '#ffffff',
        }}
      >
        <div style={{fontSize: 32, lineHeight: 1.5, textAlign: 'center', marginBottom: 80}}>
          AI素养水平测试
        </div>
        <div style={{display: 'flex', justifyContent: 'space-between', margin: '0 140px'}}>
          {evaluations.map((ev, index) => (
            <div
              key={index + 'ev'}
              className="evaluation-card"
              style={{height: 365, width: 264, padding: 12}}
              onClick={() => toEvaluation(ev)}
            >
              <img src={ev.image} alt="i" />
              <div style={{fontSize: 24, lineHeight: 1.5, margin: 24, textAlign: 'center'}}>
                {ev.name}
              </div>
              <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div>分值： {ev.score}分</div>
                <div>预计耗时： {ev.time}min</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

const evaluations = [
  {
    id: 1,
    name: '初级',
    score: 100,
    time: 10,
    image: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/evaluation/exam/1.png',
  },
  {
    id: 2,
    name: '中级',
    score: 100,
    time: 15,
    image: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/evaluation/exam/2.png',
  },
  {
    id: 3,
    name: '高级',
    score: 100,
    time: 20,
    image: 'https://gli-course.obs.cn-south-1.myhuaweicloud.com/evaluation/exam/3.png',
  },
]

export default EvaluationPage
